export default (inputString) => {
  let result = inputString.replace(/\r\n/g, "\n");
  inputString = inputString.replace(/\n\r/, "\n");
  inputString = inputString.replace(/\r/, "\n");
  return result;
};
